// extracted by mini-css-extract-plugin
export default {"connections":"SuggestedConnections_connections__HE64I","buttonWrapper":"SuggestedConnections_buttonWrapper__eS2jr"};